import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {WithChildren} from '_metronic/helpers'
import {checkIsActive} from 'utility/checkvalidUrl'
import {usePermissions} from '@services/helper/permission.helper'

type Props = {
  to: string
  title: string
  fontIcon?: string
  hasBullet?: boolean
  /** When true, this item is hidden unless the user is granted the feature at `to`. */
  gated?: boolean
  /** Paths under `to` that have their own item: this one is not highlighted on them. */
  exclude?: string[]
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  fontIcon,
  hasBullet = false,
  gated = false,
  exclude = [],
}) => {
  const {pathname} = useLocation()
  const {hasFeature} = usePermissions()

  if (gated && !hasFeature(to)) return null

  return (
    <div className='menu-item'>
      <Link
        className={clsx('menu-link without-sub', {
          active: checkIsActive(pathname, to) && !exclude.some((x) => checkIsActive(pathname, x)),
        })}
        to={to}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {fontIcon && (
          <span className='menu-icon'>
            <i className={clsx('bi fs-3', fontIcon)}></i>
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
